import { mergeMap } from 'rxjs/operators';
import { IEpic, isTypeOfAndGetPayload } from '@cbridge-utils/redux-observable';
import { CoverageRuleAction } from '@cbridge-packages/coverage-rules';
import {
  RulesManagementAction, makeRuleRowModelAndState, IPermittedRuleRowModel,
} from '@cbridge-modules/rules-management-page';

export const onLoadCoverageRulesDoneEpic: IEpic = (action$) => action$.pipe(
  isTypeOfAndGetPayload(CoverageRuleAction.loadList.done),
  mergeMap((payload) => {
    const { rows, initialState } = makeRuleRowModelAndState(payload.result.rules);
    // Coverage rows are kept out of the shared IPermittedRuleRowModel union (it would force
    // `profile` onto all members); cast at this single boundary instead.
    return [RulesManagementAction.updateState({
      ...initialState,
      rules: rows as unknown as IPermittedRuleRowModel[],
    })];
  }),
);
